import React from 'react';
import { Col, Container } from 'react-bootstrap';
import { useLocation } from 'react-router-dom';
import EmploymentForm from '../../components/EmploymentForm';

function EmploymentAdd() {
  const location = useLocation();
  const isEditing = !!location.state?.id; 

  return (
    <Container className="my-4">
      <Col md={8} className="mx-auto">
      <EmploymentForm
        backlink="/employment"
        nextlink="/employment/description"
        title={isEditing ? 'Edytuj doświadczenie zawodowe' : 'Dodaj doświadczenie zawodowe'}
        subtitle={isEditing ? null : 'Zacznij od swojej ostatniej pracy.'} 
      />
      </Col>
    </Container>
  );
}

export default EmploymentAdd;